<template>
	<div class="animall" style="width: 1200px;margin: 0 auto;margin-top: 1.875rem;">
		<div style="display: flex;justify-content: center;margin-bottom: 16px;margin-right: -100px;">
			<img style="" src="../../assets/images/cesss.png" />
		</div>
		<div style="margin-left: 0px;margin-top: -60px;margin-bottom: 10px;font-size: 16px;">
		<div style="font-weight: bold;">注意事项：</div>
		<div>1、实验室的入室项目必须为纵向的科研项目。</div>
		<div>2、申请时间必须在项目的在研时间内。</div>
		</div>
		<p style="font-size: 1.5rem;text-align: center;">中心实验室入室申请表</p>
		<div style="width: 100%;border:1px solid black;">
			<div
				style=" width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						项目负责人：
					</div>
					<div>
						<a-input v-model="form.ProjectLeader" style="width: 430px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入项目负责人"></a-input>
					</div>
				</div>
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						学科：
					</div>
					<div>
						<a-input v-model="form.Subject" style="width: 430px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入学科"></a-input>
					</div>
				</div>
			</div>
			<div
				style="width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						邮箱地址：
					</div>
					<div>
						<a-input v-model="form.Email" style="width: 445px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入邮箱地址"></a-input>
					</div>
				</div>
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						联系电话：
					</div>
					<div>
						<a-input v-model="form.Tol" style="width: 445px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入联系电话"></a-input>
					</div>
				</div>
			</div>
			<div
				style="width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 100%;display: flex;font-size: 18px;margin-left: 30px;">
					<div>
						项目名称：
					</div>
					<div>
						<a-input v-model="form.EntryName" style="width: 1040px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入项目名称"></a-input>
					</div>
				</div>

			</div>
			<div
				style="width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						项目来源：
					</div>
					<div>
						<a-input v-model="form.ProjectSource" style="width: 445px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入项目来源"></a-input>
					</div>
				</div>
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						资助金额：
					</div>
					<div>
						<a-input-number v-model="form.Price"  style="width: 445px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入资助金额"></a-input-number>
					</div>
				</div>
			</div>
			<div
				style="width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 100%;display: flex;font-size: 18px;margin-left: 30px;">
					<div>
						项目起止时间：
					</div>
					<div>
						<a-input v-model="form.ProjectTime" style="width: 1040px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入项目起止时间"></a-input>
					</div>
				</div>

			</div>
			<div
				style="width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						项目联系人：
					</div>
					<div>
						<a-input v-model="form.ProjectContact" style="width: 430px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入项目联系人"></a-input>
					</div>
				</div>
				<div style="width: 45%;display: flex;font-size: 18px;">
					<div>
						联系电话：
					</div>
					<div>
						<a-input v-model="form.Xmtop" style="width: 430px;height: 92%;font-size: 16px;color: black;"  placeholder="请输入联系电话"></a-input>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 60px;border-bottom: 1px solid black;display: flex;">
				<div
					style="width: 15%;border-right: 1px solid black; display: flex;align-items: center;justify-content: center;font-size: 18px;">
					序号
				</div>
				<div
					style="width: 30%;border-right: 1px solid black;display: flex;align-items: center;justify-content: center;font-size: 18px;">
					入室人员
				</div>
				<div style="width: 55%;display: flex;align-items: center;justify-content: center;font-size: 18px;">
					联系电话
				</div>
			</div>
			<div v-for="(item,i) in peopleData" style="width: 100%;height: 60px;border-bottom: 1px solid black;display: flex;">
				<div
					style="width: 15%;border-right: 1px solid black; display: flex;align-items: center;justify-content: center;font-size: 18px;">
					{{i+1}}
				</div>
				<div
					style="width: 30%;border-right: 1px solid black;display: flex;align-items: center;justify-content: center;font-size: 18px;">
					<a-input v-model="peopleData[i].name" style="width: 100%;height: 92%;font-size: 16px;color: black;"  placeholder="请输入入室人员"></a-input>
				</div>
				<div
					style="position: relative; width: 55%;display: flex;align-items: center;justify-content: center;font-size: 18px;">
					
					<a-input v-model="peopleData[i].tol" style="width: 100%;height: 92%;font-size: 16px;color: black;"  placeholder="请输入入室人员联系电话"></a-input>
					<div v-if="$route.query.status!='详情'&&$route.query.status!='PI审核'" @click="deleteForm(i)" style="position: absolute;right: -42px;cursor: pointer;color: red;">
						删除
					</div>
					<div @click="addForm" v-if="(i+1)==peopleData.length&&($route.query.status!='详情'&&$route.query.status!='PI审核')" style="position: absolute;right: -84px;cursor: pointer;color: slateblue;">
						新增
					</div>
				</div>
			</div>
			<div
				style="width: 100%;height: 59.5px;border-bottom: 1px solid black;display: flex;align-items: center;justify-content: space-around;">
				<div style="width: 100%;display: flex;font-size: 18px;margin-left: 30px;">
					<div >
						是否仅用仪器：
					</div>
					<div  style="font-size: 16px;color: black;" v-if="$route.query.status!='详情'&&$route.query.status!='PI审核'">
						 <a-checkbox :checked="checked1" @change="onChange1">
						    是
						 </a-checkbox>
						 <a-checkbox :checked="checked2" @change="onChange2">
						    否
						 </a-checkbox>
					</div>
					<div v-else  style="font-size: 16px;color: black;">
						{{checked1?'是':'否'}}
					</div>
				</div>
			
			</div>
			<div style="font-size: 18px; width: 100%;min-height: 60px;border-bottom: 1px solid black;">
				<div style="margin-left: 30px;margin-top: 16px;">
					使用仪器名称：
				</div> 
				<div style="width: 98%;margin:  0 auto;padding: 10px 0;">
					<a-textarea v-model="form.InstrumentName" style="min-height: 100px;color: black;font-size: 16px;" placeholder="请填写使用的仪器名称" auto-size />
				</div>
			</div>
			<div v-if="state==7&&$route.query.status=='详情'" style="font-size: 18px; width: 100%;min-height: 60px;border-bottom: 1px solid black;display: flex;">
				<div style="width: 60%;min-height: 150px;">
					<div style="margin-left: 12px;">
						项目负责人意见：
					</div> 
					<div style="width: 98%;margin:  0 auto;padding: 10px 0;margin-left: 12px;">
						{{statetimebz1?statetimebz1:'同意'}}
					</div>
				</div>
				<div style="width: 40%;margin-top: 2px;margin-right: 2px;">
					<div style="width: 100%;height: 80%;display: flex;justify-content: flex-end;align-items: center;">
						<img style="width: 150px;height: 60px;margin-right: 16px;" :src="statetimeName1">
						
					</div>
					<div style="width: 100%;height: 20%;display: flex;align-items: center;justify-content: flex-end;padding-right: 16px;">
						{{statetime1}}
					</div>
				</div>
			</div>
			<div v-if="state==7&&$route.query.status=='详情'" style="font-size: 18px; width: 100%;min-height: 60px;border-bottom: 1px solid black;display: flex;">
				<div style="width: 60%;min-height: 150px;">
					<div style="margin-left: 12px;">
						中心实验室意见：
					</div> 
					<div style="width: 98%;margin:  0 auto;padding: 10px 0;margin-left: 12px;">
						{{statetimebz2?statetimebz2:'同意'}}
					</div>
				</div>
				<div style="width: 40%;margin-top: 2px;margin-right: 2px;">
					<div style="width: 100%;height: 80%;display: flex;justify-content: flex-end;align-items: center;">
						<img style="width: 150px;height: 60px;margin-right: 16px;" :src="statetimeName2">
					</div>
					<div style="width: 100%;height: 20%;display: flex;align-items: center;justify-content: flex-end;padding-right: 16px;">
						{{statetime2}}
					</div>
				</div>
			</div>
			<div v-if="state==7&&$route.query.status=='详情'" style="font-size: 18px; width: 100%;min-height: 60px;border-bottom: 1px solid black;display: flex;">
				<div style="width: 60%;min-height: 150px;">
					<div style="margin-left: 12px;">
						科研处意见：
					</div> 
					<div style="width: 98%;margin:  0 auto;padding: 10px 0;margin-left: 12px;">
						{{statetimebz3?statetimebz3:'同意'}}
					</div>
				</div>
				<div style="width: 40%;margin-top: 2px;margin-right: 2px;">
					<div style="width: 100%;height: 80%;display: flex;justify-content: flex-end;align-items: center;">
						<img style="width: 150px;height: 60px;margin-right: 16px;" :src="statetimeName3">
					</div>
					<div style="width: 100%;height: 20%;display: flex;align-items: center;justify-content: flex-end;padding-right: 16px;">
						{{statetime3}}
					</div>
				</div>
			</div>
		</div>
		<div style="font-size: 16px;color: black;margin-top: 16px;" v-if="printOver">
			*为了保证实验室公用平台的高效利用，敬请您在项目结束后 1 个月内办理出室手续，谢谢您的配合！
		</div>
		<!-- <div style="font-size: 16px;color: black;" v-if="printOver">
			*申请入室的项目必须为纵向项目，申请入室时间必须在该纵向科研项目的研究时间内。
		</div> -->
		<a-row v-if="printOver">
			<a-col :span="24">
				<div style="display: flex;justify-content: center;margin: 3.125rem 0;"
					v-if="this.$route.query.status!='详情'&&this.$route.query.status!='PI审核'">
					<a-button @click="onSubmit('1')" type="primary"
						style="width: 22.5rem;height: 3.75rem;margin: 0 7rem;">
						保存
					</a-button>
					<a-button @click="onSubmit('2')" type="primary"
						style="width: 22.5rem;height: 3.75rem;margin: 0 7rem;">
						提交
					</a-button>
				</div>
				<div style="display: flex;justify-content: center;margin: 8.125rem 0;"
					v-if="this.$route.query.status=='详情'">
					<a-button @click="$router.go(-1)" type="primary" style="width: 22.5rem;height: 3.75rem;">
						返回
					</a-button>
					<a-button v-if="state==7&&$route.query.status=='详情'" @click="print" type="primary"
						style="width: 22.5rem;height: 3.75rem;margin: 0 7rem;">
						导出
					</a-button>
				</div>
				<div style="display: flex;justify-content: center;margin: 2.125rem 0;"
					v-else-if="this.$route.query.status=='PI审核'">
					<a-popconfirm title="该实验是否审核通过?" ok-text="通过" cancel-text="否决"
						@confirm="PiCenterEntrance('1')" @cancel="PiCenterEntrance('2')">
						<a-button type="primary" style="width: 22.5rem;height: 3.75rem;">
							审核
						</a-button>
					</a-popconfirm>
				</div>
			</a-col>
		
		</a-row>
	</div>
</template>

<script>
	import {
		VerificationApply,
		SubmitCenterEntrance,
		SelIacuc,
		GetUserExperimentApplicationId,
		UpdateCenterEntrance,
		PiCenterEntrance,
		SelAuditRecords,
		
		GetUserCenterEntranceId
	} from '@/api/index.js'

	export default {
		data() {
			return{
				printOver: true,
				state:'',
				statetimebz1:'',
				statetimebz2:'',
				statetimebz3:'',
				statetime1:'',
				statetime2:'',
				statetime3:'',
				statetimeName1:'',
				statetimeName2:'',
				statetimeName3:'',
				peopleData: [{
					name: '',
					tol: ''
				}],
				checked1:false,
				checked2:false,
				form:{
					ProjectLeader:'',
					Subject:'',
					Price:'',
					Xmtop:'',
					Email:'',
					Tol:'',
					EntryName:'',
					ProjectSource:'',
					ProjectTime:'',
					ProjectContact:'',
					PersonnelInformation:'',
					IsInformation:'',
					InstrumentName:'',
					type:''
				}
			}
		},
		created() {
			if (this.$route.query.id) {
			this.getData()
			}
		},
		mounted() {
			window.addEventListener('beforeprint', () => {
				console.log(this.printOver)
				document.getElementsByTagName('body')[0].style.zoom = 0.88;
				document.getElementsByClassName('animall')[0].style.margin = '0 0 0 0px'
				this.$parent.$children[0].$el.hidden = true
				this.$parent.$children[4].$el.hidden = true
				document.title="中心实验室入室申请表"
			});
		
			window.addEventListener('afterprint', () => {
				document.getElementsByTagName('body')[0].style.zoom = 1;
				document.getElementsByClassName('animall')[0].style.margin = '1.875rem auto'
				this.$parent.$children[0].$el.hidden = false
				this.$parent.$children[4].$el.hidden = false
				this.printOver = true
				document.title = "武汉大学人民医院——科研实验室管理系统"
			});
		},
		methods: {
			print() {
				this.printOver = false
			
				setTimeout(() => {
					window.print()
				}, 100);
			},
			async UpdateCenterEntrance(data) {
				const res = await UpdateCenterEntrance(data)
				if (res.data.state) {
					if (this.form.type == 1) {
						this.$message.success("保存成功")
					} else {
						this.$message.success("修改申请成功")
					}
					this.$router.push({
						path: '/core/coreQualificationCore'
					})
				} else {
					this.$message.error(res.data.info)
				}
			},
			async PiCenterEntrance(state) {
				const res = await PiCenterEntrance({
					CenterEntranceId: this.$route.query.id,
					type: state
				})
				if (res.data.state) {
					this.$message.success(res.data.info)
					this.$router.push({
						path: '/core/coreQualificationCore'
					})
				} else {
					this.$message.error(res.data.info)
				}
			
			},
			async getData(){
				const res  = await GetUserCenterEntranceId({CenterEntranceId:this.$route.query.id})
				if(res.data.state){
					this.form.ProjectLeader =  res.data.data[0].projectLeader
					this.form.Subject =  res.data.data[0].subject
					this.form.Price =  res.data.data[0].price
					this.form.Xmtop =  res.data.data[0].xmtop
					this.form.Email =  res.data.data[0].email
					this.form.Tol =  res.data.data[0].tol
					this.form.EntryName =  res.data.data[0].entryName
					this.form.ProjectSource =  res.data.data[0].projectSource
					this.form.ProjectTime =  res.data.data[0].projectTime
					this.form.ProjectContact =  res.data.data[0].projectContact
					this.form.CenterEntranceId =  res.data.data[0].centerEntranceId
					this.peopleData =  JSON.parse(res.data.data[0].personnelInformation) 
					this.statetimebz3 =  res.data.data[0].statetimebz3
					this.statetimebz1 =  res.data.data[0].statetimebz1
					this.statetimebz2 =  res.data.data[0].statetimebz2
					this.statetime1 = res.data.data[0].statetime1
					this.statetime2 = res.data.data[0].statetime2
					this.statetime3 = res.data.data[0].statetime3
					this.statetimeName1 = res.data.data[0].statetimeName1
					this.statetimeName2 = res.data.data[0].statetimeName2
					this.statetimeName3 = res.data.data[0].statetimeName3
					this.state = res.data.data[0].state
					if(res.data.data[0].isInformation=='是'){
						this.checked1 =true
						this.checked2=false
					}
					else{
						this.checked2 =true
						this.checked1=false
					}
					this.form.InstrumentName =  res.data.data[0].instrumentName
					// this.form.type =  res.data.data[0].type
				}
			},
			addForm(){
				this.peopleData.push({
					name: '',
					tol: ''
				})
			},
			deleteForm(key){
				if(this.peopleData.length==1){
					this.$message.error('删除错误，请至少填写一行信息')
					return
				}
				this.peopleData.splice(key,1)
			},
			onChange1(){
				this.checked1 = true
				this.checked2 = false
			},
			onChange2(){
				this.checked1 = false
				this.checked2 = true
			},
			async SubmitCenterEntrance(data) {
				const res = await SubmitCenterEntrance(data)
				if (res.data.state) {
					if (this.form.type == 1) {
						this.$message.success("保存成功")
					} else {
						this.$message.success("提交申请成功")
					}
					this.$router.push({
						path: '/core/coreQualificationCore'
					})
				} else {
					this.$message.error(res.data.info)
				}
			},
			onSubmit(state) {
			// 	for (var item in this.form) {
			// 		console.log(this.form[item])
			
			// 		if (item == 'EthicalReviewForTeachId') {
			
			// 			if (!this.form[item]) {
			// 				this.$message.error('请选择项目后再提交')
			
			// 				return
			// 			}
			// 		}
			// 	}
				if (!this.$route.query.id) {
					if (state == 2) {
						this.form.type = state
						this.form.PersonnelInformation = JSON.stringify(this.peopleData) 
						this.form.IsInformation = this.checked1?'是':'否'
						this.SubmitCenterEntrance(this.form)
					}
					if (state == 1) {
						this.form.type = state
						this.form.PersonnelInformation = JSON.stringify(this.peopleData) 
						this.form.IsInformation = this.checked1?'是':'否'
						this.SubmitCenterEntrance(this.form)
					}
				} else {
					if (state == 2) {
						this.form.PersonnelInformation = JSON.stringify(this.peopleData) 
						this.form.IsInformation = this.checked1?'是':'否'
						this.UpdateCenterEntrance(this.form)
					}
					if (state == 1) {
						this.form.type = state
						// this.form.ExperimentTime = moment(this.form.ExperimentTime).format('YYYY-MM-DD HH:mm:ss')
						this.form.PersonnelInformation = JSON.stringify(this.peopleData) 
						this.form.IsInformation = this.checked1?'是':'否'
						this.UpdateCenterEntrance(this.form)
					}
				}
			
			},
		}
	}
</script>
<style>
	body{
		color: black !important;
	}
	.animall .ant-input {
		border-color: transparent !important;
		/* cursor: pointer; */
	}
	
	.animall .ant-select div {
		border-color: transparent !important;
		/* cursor: pointer; */
	}
	
	.animall .ant-descriptions-item-label {
		font-size: 22px !important;
		font-weight: 500;
	}
	.animall .ant-input-number{
		border-color: transparent !important;
	}
	.animall .ant-checkbox-checked {
		background: #1890ff !important;
	}
</style>
